import React from "react";
import PropTypes from 'prop-types';

export default class DateStart extends React.PureComponent
{
    static propTypes = {
        type: PropTypes.string,
        language: PropTypes.string,
        date : PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            type : this.props.type,
            date : this.props.date
        };
    }

    render() {
        if (this.state['type'] === 'date' && (this.state['date'] === undefined || this.state['date'] === null)) {
            return null;
        }
        return (
            <li><span>{window.Translator.getSlug('DateStart', this.props.language)}: </span>
                {this.state['type'] !== 'date' ? (this.state['type'] === 'asap' ? 'ASAP' : window.Translator.getSlug('Agreement', this.props.language)) : this.renderDate()}
            </li>
        );
    }

    renderDate = () => {
        let dateOptions = {year: "numeric", month: "numeric", day: "numeric"};
        let dateObj = new Date(this.state['date']);
        return dateObj.toLocaleString(this.props.language, dateOptions);
    };

}